import api from "./api";
import auth from "./auth";

const BASE_SERVICE_URL = "dstore-service/v1/api/cms/dstore/design/";

export default {
    getDesigns: function() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "list", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getDesignDetails(uuid) {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + uuid, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(errors);
                });
        });
    },
    createDesign(data) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "create", data, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    if (errors == undefined) {
                        reject(status.errors.message);
                    } else {
                        reject(errors);
                    }
                });
        });
    },
    updateDesign(uuid, data) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + uuid, data, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    if (errors == undefined) {
                        reject(status.errors.message);
                    } else {
                        reject(errors);
                    }
                });
        });
    },
    publishDesign(data) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "publish/" + data.uuid,
                { publish: data.publish },
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(errors);
                });
        });
    },
    deleteDesign(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(BASE_SERVICE_URL + uuid, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(errors);
                });
        });
    },
    getMerchantDesigns() {
        return new Promise((resolve, reject) => {
            api.post("design-service/merchant/list", {}, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(errors);
                });
        });
    },
    getMerchantDesignDetails(uuid) {
        return new Promise((resolve, reject) => {
            api.get("design-service/merchant/view/" + uuid, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(errors);
                });
        });
    },
    createMerchantDesign(data) {
        return new Promise((resolve, reject) => {
            api.post("design-service/merchant/create", data, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(errors);
                });
        });
    },
    updateMerchantDesign(uuid, data) {
        return new Promise((resolve, reject) => {
            api.post(
                "design-service/merchant/update/" + uuid,
                data,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(errors);
                });
        });
    },
    publishMerchantDesign(data) {
        return new Promise((resolve, reject) => {
            api.post(
                "design-service/merchant/publish/" + data.uuid,
                { published: data.published },
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(errors);
                });
        });
    },
    deleteMerchantDesign(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(
                "design-service/merchant/delete/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(errors);
                });
        });
    },
    publishFeatureBanner(param) {
        return new Promise((resolve, reject) => {
            api.post(
                "design-service/feature/banner/create",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    viewFeatureBanner(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                "design-service/feature/banner/view/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    updateFeatureBanner(uuid, data) {
        return new Promise((resolve, reject) => {
            api.post(
                "design-service/feature/banner/update/" + uuid,
                data,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    deleteFeatureBanner(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(
                "design-service/feature/banner/delete/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    getFeaturedBannerList() {
        return new Promise((resolve, reject) => {
            api.get("design-service/feature/banner/list", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    saveWebDesign(param) {
        return new Promise((resolve, reject) => {
            api.post("design-service/web/create", param, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    getWebDesigns() {
        return new Promise((resolve, reject) => {
            api.get("design-service/web/list", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    deleteWebDesign(uuid) {
        return new Promise((resolve, reject) => {
            api.delete("design-service/web/delete/" + uuid, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    viewWebDesign(uuid) {
        return new Promise((resolve, reject) => {
            api.get("design-service/web/view/" + uuid, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    updateWebDesign(uuid, data) {
        return new Promise((resolve, reject) => {
            api.post(
                "design-service/web/update/" + uuid,
                data,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    publishWebDesign(param) {
        console.log(param);
        return new Promise((resolve, reject) => {
            api.post(
                "design-service/web/publish/" + param.uuid,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    },
    // News & Pop Up
    getNewsPopUp(param) {
        return new Promise((resolve, reject) => {
            api.get(
                `design-service/news-pop-up/list/${param}`,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, errors) => {
                    reject(status, errors);
                });
        });
    }
};
